import React, { memo, MouseEventHandler } from 'react';
import { OveitIcon, OveitIconType } from '../OveitIcon';

interface PrimaryButtonProps {
  className?: string;
  label: string;
  onClick?: MouseEventHandler;
  disabled?: boolean;
  type?: 'blue' | 'green';
  icon?: OveitIconType;
  iconLeft?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = memo(
  ({ type, className, disabled, onClick, icon, iconLeft, label }) => {
    return (
      <button
        className={`btn-${type || 'blue'} ${
          className !== undefined ? className : ''
        } ${
          !!disabled ? 'disabled' : ''
        } button flex items-center cursor-pointer`}
        onClick={onClick}
        disabled={!!disabled}
      >
        {!!iconLeft && icon && <OveitIcon name={icon} />}
        {label}
        {!iconLeft && icon && <OveitIcon name={icon} />}
      </button>
    );
  },
);

export default PrimaryButton;
